import React from 'react';
import TrendBadge from './TrendBadge';

/**
 * StatCard - KPI stat card with icon, label, value, and optional trend.
 */
const StatCard = ({
    icon: Icon,
    label,
    value,
    subtitle,
    trend,
    trendLabel,
    color = 'text-violet-600',
    loading = false
}) => {
    if (loading) {
        return (
            <div className="sd-card sd-card--stat">
                <div className="sd-stat__icon">
                    <div className="loading-skeleton" style={{ width: '1.5rem', height: '1.5rem', borderRadius: 'var(--radius-md)' }} />
                </div>
                <div className="sd-stat__content">
                    <div className="loading-skeleton" style={{ width: '6rem', height: '0.75rem', borderRadius: 'var(--radius-sm)' }} />
                    <div className="loading-skeleton" style={{ width: '4rem', height: '1.75rem', borderRadius: 'var(--radius-sm)' }} />
                    <div className="loading-skeleton" style={{ width: '5rem', height: '0.75rem', borderRadius: 'var(--radius-sm)' }} />
                </div>
            </div>
        );
    }

    const displayValue = typeof value === 'number' ? value.toLocaleString() : value;

    return (
        <div className="sd-card sd-card--stat">
            <div className="sd-stat__icon">
                {Icon && (
                    <Icon size={22} className={color.replace('bg-', 'text-')} />
                )}
            </div>
            <div className="sd-stat__content">
                <p className="sd-stat__label">{label}</p>
                <p className="sd-stat__value">{displayValue}</p>
                {subtitle && (
                    <p className="sd-stat__subtitle">{subtitle}</p>
                )}
                {trend !== undefined && (
                    <TrendBadge value={trend} label={trendLabel} size="sm" />
                )}
            </div>
        </div>
    );
};

export default StatCard;
